import { Configuration } from '@pixelverse/strichjs-sdk';
import { BarcodeFormat, DecodeHintType } from '@zxing/library';

export const strichConfig: Configuration = {
  selector: '#scanner',
  engine: {
    symbologies: [
      'datamatrix',
      'ean13',
      'code128',
      'code39',
      'code93',
      'codabar',
      'i25',
    ],
    duplicateInterval: 1500,
    hysteresisInterval: 50,
    invertedCodes: true,
  },
  locator: {
    regionOfInterest: {
      left: 0.25,
      right: 0.25,
      top: 0.35,
      bottom: 0.35,
    },
  },
  feedback: {
    audio: true,
    vibration: true,
  },
  overlay: {
    focusOnTap: false,
  },
  frameSource: {
    resolution: 'auto',
  },
};

export const DUPLICATE_INTERVAL_MS = 1500;

export const zxingHints = new Map<DecodeHintType, unknown>([
  [
    DecodeHintType.POSSIBLE_FORMATS,
    [
      BarcodeFormat.DATA_MATRIX,
      BarcodeFormat.EAN_13,
      BarcodeFormat.CODE_128,
      BarcodeFormat.CODE_39,
      BarcodeFormat.CODE_93,
      BarcodeFormat.CODABAR,
      BarcodeFormat.ITF,
    ],
  ],
]);
